/**
 *  Planner app id which uniquely identifies the app in OCV
 */ export const PlannerAppOCVId = 2204;
/**
 * Feedback button id in Uno
 */ export const FeedbackButtonId = "FeedbackButtonIdInUno";
/**
 * Feature areas to be logged in OCV, 'featureArea' is intended to represent a broader functional domain or application module. It is typically used for filtering and grouping feedback across related features.
 */ export var OcvFeatureAreas = /*#__PURE__*/ function(OcvFeatureAreas) {
    // Copilot related features in basic plans
    OcvFeatureAreas["GsdInBasicPlansFeedback"] = "Copilot GSD in Basic Plans";
    // Status report in premium plans
    OcvFeatureAreas["StatusReportFeedback"] = "Status Report in Premium Plans";
    // Status report in Evo Plans
    OcvFeatureAreas["StatusReportInEvoPlansFeedback"] = "Status Report in Evo Plans";
    // Sydney status report in Evo Plans
    OcvFeatureAreas["StatusReportInEvoPlanSydneyFeedback"] = "Status Report in Evo Plans Sydney";
    // Copilot related features in premium plans
    OcvFeatureAreas["GsdInPremiumPlansFeedback"] = "Copilot GSD in Premium Plans";
    // Copilot chat feature
    OcvFeatureAreas["CopilotChatFeedback"] = "Copilot Planner";
    // Planner Agent in Planner
    OcvFeatureAreas["PMAInPlannerFeedback"] = "Planner Agent in Planner";
    return OcvFeatureAreas;
}({});
